
import React, { useState, useEffect } from 'react';
import hanjaData from '../data/hanjaData.json';
import HanjaCanvas from '../components/HanjaCanvas';
import { Box, Button, Typography, Slider } from '@mui/material';

interface PracticePageProps {
  isRandom: boolean;
  penThickness: number;
  hanjaDisplaySize: number;
}

const PracticePage: React.FC<PracticePageProps> = ({ isRandom, penThickness, hanjaDisplaySize }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hanjaList, setHanjaList] = useState(hanjaData);

  useEffect(() => {
    if (isRandom) {
      setHanjaList([...hanjaData].sort(() => Math.random() - 0.5));
    } else {
      setHanjaList(hanjaData);
    }
    setCurrentIndex(0); // Reset index when mode changes
  }, [isRandom]);

  const currentHanja = hanjaList[currentIndex];

  const goToNext = () => {
    setCurrentIndex(prev => (prev + 1) % hanjaList.length);
  };

  const goToPrev = () => {
    setCurrentIndex(prev => (prev - 1 + hanjaList.length) % hanjaList.length);
  };

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setCurrentIndex(newValue as number);
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="h4" gutterBottom>{isRandom ? '랜덤 연습' : '순서대로 연습'}</Typography>
      <HanjaCanvas 
        hanja={currentHanja} 
        currentIndex={currentIndex} 
        totalHanja={hanjaList.length} 
        penThickness={penThickness} 
        hanjaDisplaySize={hanjaDisplaySize} 
      />
      <Box sx={{ width: 300, mt: 2, mx: 'auto' }}>
        {!isRandom && (
          <Slider
            value={currentIndex}
            onChange={handleSliderChange}
            min={0}
            max={hanjaList.length - 1}
            aria-labelledby="discrete-slider"
            valueLabelDisplay="auto"
            marks
          />
        )}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button variant="contained" onClick={goToPrev} sx={{ mr: 2 }}>이전</Button>
          <Button variant="contained" onClick={goToNext}>다음</Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PracticePage;
